import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export function ContactUsIcon(props: IconProps) {
  return (
    <IconBase viewBox="0 0 24 24" {...props} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.636 5.045H19.363C20.267 5.045 21 5.778 21 6.682V17.318C21 18.222 20.267 18.954 19.364 18.954H4.636C3.733 18.955 3 18.222 3 17.318V6.682C3 5.778 3.733 5.045 4.636 5.045Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.11719 6.075L10.8112 11.578C11.5062 12.075 12.4402 12.076 13.1362 11.58L20.8742 6.061"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
}

export default ContactUsIcon;
